import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'
import { components } from '@plandi/common/src/generated'

import { projectKeys } from '../projects.constants'
import { projectsApi } from '../projects.api'
import { useLocale } from '@plandi/common'

export const useQueryProjectChatMessagesByChatId = <
  T = components['schemas']['ChatMessageListResource']['data'] | undefined
>(
  chatId?: number,
  options?: UseQueryOptions<
    components['schemas']['ChatMessageListResource']['data'] | undefined,
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const data = useQuery(
    [projectKeys.chat(chatId as number), locale],
    () => {
      if (chatId) {
        return projectsApi.getProjectChatMessagesByChatId(chatId, locale)
      }
    },
    options
  )

  return data
}
